import BasicContentAttachments from './BasicContentAttachments';

export { type BasicContentAttachmentsProps } from './BasicContentAttachments';
export default BasicContentAttachments;
